






import Vue from "vue";
import VueShowdown from "vue-showdown";

// This is a passthrough component which is used to house all the styling needed to for rendering the markdown
// generated html.
// The style block of this vue is intentionally unscoped so that the styling affects VueShowdown's tags.
export default Vue.extend({
  name: "showdownContainer",
  props: {
    markdownContent: String,
  },
});
